export default "__VITE_ASSET__DWqiqoVo__"